import { createBrowserRouter, RouterProvider } from "react-router-dom";

import ModuleEmptyPage from "../components/emptyPage";
import BackLogin from "../page/login";
import BackLoginAdmin from "../page/loginAdmin";

import BackRoutes from "./back";
import MemberRoutes from "./member";

export default function CreatRoute() {
  const router = createBrowserRouter([
    {
      path: "",
      element: <BackLogin />,
    },
    {
      path: "/login",
      element: <BackLogin />,
    },
    {
      path: "/loginAdmin",
      element: <BackLoginAdmin />,
    },
    ...BackRoutes.routes,
    ...MemberRoutes.routes,
    {
      path: "*",
      element: <ModuleEmptyPage />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}
